import { useAppSelector } from "@/reducers/hooks"
import {
  selectActiveChat,
  selectChatMessagesWithAppliedRetractionsMemo,
} from "@/reducers/chatsSliceSelectors"
import { useMemo } from "react"
import { Message as MessageType } from "@/reducers/messagesSlice"

function useReplyMessage(message: MessageType) {
  const activeChat = useAppSelector(selectActiveChat)
  const chatMessages = useAppSelector((state) =>
    selectChatMessagesWithAppliedRetractionsMemo(state, activeChat),
  )

  return useMemo(() => {
    return chatMessages.find((msg) => msg.id === message.replyMessage?.id)
  }, [chatMessages, message.replyMessage?.id])
}

export default useReplyMessage
